import { createStore, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import reducer from './reducer';
import storeLoggerMiddleware from './loggerMiddleware';

const middleware = [thunk, storeLoggerMiddleware]; // logger mw must be last

const store = createStore(combineReducers({ uploader: reducer }), applyMiddleware(...middleware));

export default () => store;
